// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1ODEY","signatureButtonsRight":"ModalSign_signatureButtonsRight__12V20"};